import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid, useMediaQuery } from "@material-ui/core";
import {
    ButtonHLPure,
    InputHLPure,
    TextAreaHLPure,
    InputFileHLPure,
    DropDownBtnHLPure,
    DialogSystemGLPure,
    ArrowBtnHLPure
} from "../../../pures"
import "./digital-contract-template-add.css";
import PdfViewerAction from '../../../actions/pdf-viewer/pdf-viewer.action'

const DigitalContractTemplatesDetailAdd = ({
    selectedCompanies,
    getVariablesFromDoc,
    createTemplate,
    options,
    hideShowDetails,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    toggleErrorRequesting,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    stateNameComponentUser,
    setLastStateNameComponentUser,
    message
}) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [errorFile, setErrorFile] = useState(false);
    const [selectedFileName, setSelectedFileName] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(selectedCompanies);
    const [deletePfd, setDeletePfd] = useState(false);
    const [selectedFileBase64, setSelectedFileBase64] = useState(false);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [blobUrl, setBlobUrl] = useState('')
    const [file, setFile] = useState('')
    const [displayPdf, setDisplayPdf] = useState(true)

    const { t } = useTranslation();
    const pdf = useMemo(() => {
        return <PdfViewerAction url={blobUrl} isExtended={false} isSSRActive={false} />
    }, [blobUrl])

    const mobileResolution = useMediaQuery("(max-width:912px)");

    useEffect(() => {
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl)
            }
        }
    }, [blobUrl])

    const redirectToComponets = (name) => {
        setLastStateNameComponentUser(t("digitalContractDashboard.templates.routerAdd"))
        setStateNameComponentUser(name);
        setHeaderTitleinDetail({ clicked: true, name: name })
    };

    const handleNameInput = (e) => {
        setName(e.target.value);
    };

    const handleDescriptionInput = (e) => {
        setDescription(e.target.value);
    };

    //Funtion to check the pdf extension
    const handleFile = async (e) => {
        if (!e.target.files[0]) return
        let errorMessage = 'Ocurrió un error al validar las variables del documento'
        let errorNoDocx = 'Solo se permiten archivos con extension .docx'
        toggleLoadingRequesting(true)
        //File extension .docx
        let result = e.target.files[0].name.slice(-5);
        if (result === ".docx" || result === ".DOCX") {
            setSelectedFile(e.target.files[0]);
            setSelectedFileName(e.target.files[0].name);
            setErrorFile(false);
            try {
                let documentVariable = await getVariablesFromDoc(e.target.files[0])
                if (documentVariable && documentVariable.data && Number(documentVariable.statusCode) === 200) {
                    setQuantity(documentVariable.data.Quantity)
                    const arr = new Uint8Array(documentVariable.data.pdfBuf.data).buffer
                    setFile(arr)
                    const blob = new Blob([arr], { type: 'application/pdf' })
                    const url = URL.createObjectURL(blob)
                    setBlobUrl(url)
                    toggleLoadingRequesting(false)
                    toggleCompletedRequesting(true)
                } else if (Number(documentVariable.statusCode) === -2) {
                    setSelectedFile(null);
                    setErrorFile(true);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else if (Number(documentVariable.statusCode) === -3) {
                    setSelectedFile(null);
                    setErrorFile(true);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else if (Number(documentVariable.statusCode) === -4) {
                    setSelectedFile(null);
                    setErrorFile(true);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, documentVariable.message)
                } else {
                    setSelectedFile(null);
                    setErrorFile(true);
                    setSelectedFileBase64("")
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, errorMessage)

                }
            } catch (error) {
                setSelectedFile(null);
                setErrorFile(true);
                setSelectedFileBase64("")
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, errorMessage)
            }
        } else {
            toggleLoadingRequesting(false)
            setSelectedFile(null);
            setErrorFile(true);
            setSelectedFileBase64("")
            toggleErrorRequesting(true, errorNoDocx)
            return false;
        }
    };


    //Function to delete the uploaded file
    const handleDeleteFile = (e) => {
        setSelectedFile(null);
        setErrorFile(false);
        setQuantity(0)
        setSelectedFileName(false)
        if (blobUrl) {
            URL.revokeObjectURL(blobUrl)
            setBlobUrl('')
        }
        setFile('')
        return true;
    };

    const filterChange = (e) => {
        // const selectedOption = strToboolean(e.target.value);
        const selectedOption = e.target.value;
        setSelectedCompany(selectedOption);
    };

    const handleSave = () => {
        createTemplate(selectedCompany, name, description, selectedFile);
    };

    return (
        < Grid
            item
            className="digitalContractTemplatesAdd-body"
            xs={12}
        >

            {/*Container primera seccion de items, fila*/}
            <Grid
                container
                spacing={4}
            >
                <Grid
                    item
                    md={6}
                    xs={12}
                    className={displayPdf ? null : "digitalContractTemplateNone"}>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <DropDownBtnHLPure
                                labelDropDown={t("digitalContractTemplatesAdd.Company")}
                                optionsDropDown={options ? options : null}
                                optionsValue={selectedCompany}
                                nameOption="companyName"
                                valueItem="id"
                                flex={false}
                                // tooltipShow={true}   
                                informationIcon={true}
                                onDropDownChange={(event) => filterChange(event)}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputHLPure
                                labelInput={t("digitalContractTemplatesAdd.Name")}
                                typeInput={"text"}
                                valueInput={name}
                                handleChangeInput={handleNameInput}
                                tooltipShow={true}
                                positionTooltip={mobileResolution ? 'top' : 'right'}
                                titleTooltip={t("digitalContractTemplatesAdd.NameTooltipTitle")}
                                descriptionTooltip={t("digitalContractTemplatesAdd.NameTooltipDescription")}
                                informationIcon={true}
                                inputActive={true}
                            />
                        </Grid>

                        <Grid item xs={12} className="digitalContractTemplatesAddInputFile">
                            <InputFileHLPure
                                messageBtn={t("digitalContractTemplatesAdd.Document")}
                                flex={false}
                                acceptFile={".doc, .docx, application/msword"}
                                selectedFile={selectedFile}
                                selectedFileName={selectedFileName}
                                // errorFile={errorFile}
                                handleFile={e => handleFile(e)}
                                handleDeleteFile={e => handleDeleteFile(e)}
                                tooltipShow={true}
                                positionTooltip={mobileResolution ? 'top' : 'right'}
                                titleTooltip={t('digitalContractTemplatesAdd.DocumentTooltipTitle')}
                                descriptionTooltip={t('digitalContractTemplatesAdd.DocumentTooltipDescription')}
                                labelActive={false}
                                informationIcon={true}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputHLPure
                                labelInput={t("digitalContractTemplatesAdd.Variables")}
                                typeInput={"text"}
                                disabled={true}
                                errorInputText={"Error"}
                                valueInput={quantity}
                                inputActive={true}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextAreaHLPure
                                labelTextArea={t("digitalContractTemplatesAdd.Description")}
                                valueTextData={description}
                                handleChangeTextArea={handleDescriptionInput}
                                errorTextArea={"Error"}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    item
                    md={6}
                    xs={12}
                    className={displayPdf && mobileResolution ? "digitalContractTemplateNone" : "digitalContractTemplatesAddContainer"}>
                    {blobUrl !== '' ?
                        pdf
                        :
                        <div className="digitalContractTemplatePdfNoImage">
                            {t("digitalContractDashboard.templates.details.noTemplateUploaded")}
                        </div>}
                </Grid>
            </Grid>
            <Grid
                container
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalContractTemplatesDetailAdd-container-btns"
            >
                <Grid
                    item
                    className="digitalContractTemplatesAddArrowButton"
                >
                    <ArrowBtnHLPure
                        textArrowBtn={displayPdf ? 'Ver template' : "Regresar"}
                        // onClickArrowBtn={(e) => redirectToComponets('Pdf')}
                        onClickArrowBtn={(e) => setDisplayPdf(!displayPdf)}
                    />
                </Grid>
                <Grid
                    item
                    className={displayPdf ? "digitalContractTemplatesAddCancelButton" : "digitalContractTemplateNone"}
                >
                    <ButtonHLPure nameBtn={t("button.cancel")} onClickBtn={hideShowDetails} />
                </Grid>
                <Grid
                    item
                    className={displayPdf ? "digitalContractTemplatesAddSaveButton" : "digitalContractTemplateNone"}
                >
                    <ButtonHLPure primary nameBtn={t("button.save")} onClickBtn={handleSave} />
                </Grid>
                <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    showCompletedRequesting={showCompletedRequesting}
                    showErrorRequesting={showErrorRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    message={message}
                />
            </Grid>
            {/*Seccion de fila para footer */}
        </Grid >
    );
};

export default DigitalContractTemplatesDetailAdd;